import React from 'react'
import RequestErrorModal from 'view/component/request-error-modal'
import * as NAVIGATION from 'constant/actions/navigation'

export default store => next => action => {
  if (action.type.includes('_FULFILLED')) {
    if (!action.payload.data.success) {
      if (action.payload.data.error) {
        store.dispatch({
          type: NAVIGATION.NAVIGATION_SHOW_MODAL,
          modalContent: <RequestErrorModal errorMessage={action.payload.data.message.toString()} />
        })
      }
    }
  }
  next(action)
}
